// Utility functions used across template preview components

export function parseButtons(data = {}, components = null) {
  // priority: explicit buttons array on data
  if (Array.isArray(data.buttons) && data.buttons.length > 0) {
    return data.buttons;
  }

  let comps = components;
  if (typeof comps === 'string') {
    try {
      comps = JSON.parse(comps);
    } catch (e) {
      comps = null;
    }
  }

  let buttonsComponent = null;
  if (Array.isArray(comps)) {
    buttonsComponent = comps.find(c => c.type === 'BUTTONS');
  } else if (comps && typeof comps === 'object') {
    buttonsComponent = comps.BUTTONS;
  }

  if (!buttonsComponent) return [];
  try {
    const btnComp = typeof buttonsComponent === 'string'
      ? JSON.parse(buttonsComponent)
      : buttonsComponent;
    if (Array.isArray(btnComp.buttons)) {
      return btnComp.buttons.map((b) => {
        switch (b.type) {
          case 'PHONE_NUMBER':
            return { type: 'CALL', text: b.text, phoneNumber: b.phone_number || b.phoneNumber };
          case 'URL':
            return { type: 'URL', text: b.text, url: b.url || b.link || '#' };
          case 'QUICK_REPLY':
            return { type: 'QUICK_REPLY', text: b.text };
          case 'COPY':
            return { type: 'COPY', text: b.text, sample: b.sample || '' };
          case 'COPY_CODE':
            return { type: 'COPY_CODE', text: b.text, sample: b.example || b.sample || '' };
          default:
            return { type: 'QUICK_REPLY', text: b.text };
        }
      });
    }
  } catch (e) {
    // ignore parse errors
  }
  return [];
}

export function getMediaTypeFromComponents(components) {
  let comps = components;
  if (typeof comps === 'string') {
    try {
      comps = JSON.parse(comps);
    } catch (e) {
      comps = null;
    }
  }

  let headerComponent = null;
  if (Array.isArray(comps)) {
    headerComponent = comps.find(c => c.type === 'HEADER');
  } else if (comps && typeof comps === 'object') {
    headerComponent = comps.HEADER;
  }

  if (!headerComponent) return 'none';
  try {
    const headerParsed = typeof headerComponent === 'string'
      ? JSON.parse(headerComponent)
      : headerComponent;
    const format = headerParsed?.format?.toLowerCase();
    if (['image', 'video', 'document', 'audio'].includes(format)) {
      return format;
    }
  } catch (e) {
    // ignore
  }
  return 'none';
}

export function formatText(text = '', sampleValues = {}) {
  if (!text) return '';
  return text.replace(/{{\s*([^{}]+?)\s*}}/g, (match, name) => {
    const val = sampleValues && Object.prototype.hasOwnProperty.call(sampleValues, name) ? sampleValues[name] : '';
    return val !== '' ? val : match;
  });
}

export function extractTemplateVariables(text) {
  if (!text) return [];
  const regex = /\{\{\s*([^{}]+?)\s*\}\}/g;
  const variables = [];
  let match;
  while ((match = regex.exec(text)) !== null) {
    const varName = match[1].trim();
    if (!variables.includes(varName)) {
      variables.push(varName);
    }
  }
  return variables;
}
